import React from 'react';
import { CreateAgencyWizardStepProps } from '../types';
import AgencyDescriptionForm, { AgencyDescriptionFormModel } from '../../../components/agency-description-form/AgencyDescriptionForm';

const AgencyDescriptionWizardStep: React.FC<CreateAgencyWizardStepProps> = ({
  initialData,
  loading = false,
  formRef,
  onSubmit,
}) => {
  const onInternalSubmit = React.useCallback((formValues: AgencyDescriptionFormModel) => {
    // TODO: Fix the type in bricks
    const isFormDirty = (formRef?.current as any)?.dirty ?? false;

    onSubmit({
      ...initialData,
      description: formValues.description.trim() || undefined,
    }, isFormDirty);
  }, [formRef, initialData, onSubmit]);

  return (
    <AgencyDescriptionForm
      initialValues={{
        description: initialData?.description || '',
      }}
      innerRef={formRef}
      onSubmit={onInternalSubmit}
      loading={loading}
    />
  );
};

export default AgencyDescriptionWizardStep;
